export default __webpack_public_path__ + "static/media/icon2.e744f462.svg";